import { type ResponseSuccess, type APIError } from '@terros/common'
import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import { useServerRequest } from './api'

type MutationInput<ApiSuccess> = {
  url: string
  onSuccess?: (data: ApiSuccess) => void
}

export function useTantalimMutation<ApiInput, ApiSuccess extends ResponseSuccess>({
  url,
  onSuccess,
}: MutationInput<ApiSuccess>): TantalimMutationResponse<ApiInput, ApiSuccess> {
  const serverRequest = useServerRequest<ApiInput, ApiSuccess>(url)

  return useMutation<ApiSuccess, APIError, ApiInput>({ mutationFn: serverRequest, onSuccess })
}

export type TantalimMutationResponse<ApiInput, ApiSuccess> = UseMutationResult<ApiSuccess, APIError, ApiInput>
